import { useDeviceDetect } from '@fable/hooks'
import useShowQrModal from './useShowQrCodeModal'
import { getReferralId, handleDeeplink } from 'utils'
import { analytics } from 'segment_analytics'
import { Club, ClubType } from '@fable/types'
import { useActions, useTypedSelector } from 'hooks'
import { FORM_TYPES } from 'app/auth/constants'

const useClubDetailJoinButtonPublic = ({
  isPremium,
  state,
  club,
  clubType,
}: {
  isPremium: boolean
  state: any
  club: Club | null
  clubType: ClubType
}) => {
  const { isMobile } = useDeviceDetect()
  const { showQrCodeModal, promoTest } = useShowQrModal(state)
  const { isAuthenticated } = useTypedSelector(({ auth }) => auth)
  const { openAuthModal } = useActions()
  const { id } = getReferralId()
  const hasReferralId = !isAuthenticated && !!id

  const handleClick = () => {
    if (hasReferralId) {
      openAuthModal(FORM_TYPES.SIGN_UP)
      return
    }

    if (isMobile && !promoTest.active) {
      analytics.events.appDownload({ clubType: clubType })
      handleDeeplink(club?.deep_link_url)
      return
    }

    return showQrCodeModal()
  }

  const getTitle = () => {
    if (hasReferralId) return 'Sign up'

    return `Download the app to ${isPremium ? 'start your trial' : 'join'}`
  }

  return {
    handleClick,
    title: getTitle(),
  }
}

export default useClubDetailJoinButtonPublic
